<div id="request-page-1" *ngIf="templateView==1">
    <h2 class="mt-5 font-weight-bolder"><i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "REQUEST.TITLE" | translate }}</h2>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="row mx-3">
                <div class="col-md-12 my-5">
                    <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                </div>
            </div>
            <div class="form-group row mx-3 justify-content-md-left">
                <div class="col-md-12">
                    <form
                    [formGroup]="filterRequestForm"
                    (ngSubmit)="submitFilterRequest()"
                    >

                        
                        <div class="row mb-4">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.CATEGORY" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdCategoriaSolicitud" name="inputIdCategoriaSolicitud" (change)="changeFilterCategoria($event.target, false)">
                                        <option value="" selected>{{ "REQUEST.SELECT_CATEGORY" | translate }}</option>
                                        <option *ngFor="let item of categorias  | async" value="{{item.IdCategoriaSolicitud}}">{{ "REQUEST.CATEGORY" | translate }} {{ item.CategoriaSolicitud }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4" *ngIf="filterRequestForm.value.inputIdCategoriaSolicitud == 1">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.PRODUCER" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdEntidadAgencia" name="inputIdEntidadAgencia" (change)="changeAgenciaSucursal($event.target)">
                                        <option value="" selected>{{ "REQUEST.SELECT_PRODUCER" | translate }}</option>
                                        <option *ngFor="let item of agencias  | async" value="{{item.IdEntidadAgencia}}">{{ item.Agencia }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4" *ngIf="filterRequestForm.value.inputIdCategoriaSolicitud == 2">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.BRANCH" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdEntidadSucursal" name="inputIdEntidadSucursal" (change)="changeAgenciaSucursal($event.target)">
                                        <option value="" selected>{{ "REQUEST.SELECT_BRANCH" | translate }}</option>
                                        <option *ngFor="let item of sucursales  | async" value="{{item.IdEntidadSucursal}}">{{ item.Sucursal }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4" *ngIf="filterRequestForm.value.inputIdCategoriaSolicitud && (filterRequestForm.value.inputIdEntidadAgencia || filterRequestForm.value.inputIdEntidadSucursal)">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.SALE_EXECUTIVE" | translate }}</label>
                                    <select class="form-control inputIdEntidadAgente" formControlName="inputIdEntidadAgente" name="inputIdEntidadAgente">
                                        <option value="" >{{ "REQUEST.SALE_EXECUTIVE" | translate }}</option>
                                        <option *ngFor="let item of agentes  | async" value="{{item.IdEntidadAgente}}">{{ item.Agente }}</option>
                                    </select>
                                </div>
                            </div>

                            
                            <div class="col-md-12"></div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.POLICY_NUM" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'REQUEST.POLICY_NUM' | translate }}" formControlName="inputNroPoliza" name="inputNroPoliza">
                                </div>
                            </div>

                            <!--div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.POLICY_NUM" | translate }}</label>
                                    <select class="form-control inputIdPoliza" formControlName="inputIdPoliza" name="inputIdPoliza">
                                        <option value="">{{ "REQUEST.SELECT_POLICY_NUM" | translate }}</option>
                                        <option *ngFor="let item of agencias  | async" value="{{item.IdEntidadAgencia}}">{{ item.Agencia }}</option>
                                    </select>
                                </div>
                            </!--div -->

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.BUSINESS_LINE" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdLineaNegocioSolicitud" name="inputIdLineaNegocioSolicitud">
                                        <option value="">{{ "REQUEST.SELECT_BUSINESS_LINE" | translate }}</option>
                                        <option *ngFor="let item of lineanegocios  | async" value="{{item.IdLineaNegocioSolicitud}}">{{ item.LineaNegocioSolicitud }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.PROSPECT" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'REQUEST.PROSPECT' | translate }}" formControlName="inputProspecto" name="inputProspecto">
                                </div>
                            </div>

                            <div class="col-md-8">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.DESCRIPTION" | translate }}</label>
                                    <textarea class="form-control"  name="inputDescripcion" formControlName="inputDescripcion" placeholder="{{ 'REQUEST.DESCRIPTION' | translate }}" row="3" style="width: 100%;"></textarea>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="sr-only">{{ "REQUEST.STATUS" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdStatus" name="inputIdStatus">
                                        <option value="">{{ "REQUEST.SELECT_STATUS" | translate }}</option>
                                        <option *ngFor="let item of estatus  | async" value="{{item.IdEstatus}}">{{ item.Estatus }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row justify-content-between">
                            <div class="col-md-4">
                                <div class="form-group mb-0 text-left"
                                
                                >
                                    <button type="button" class="btn btn-secondary text-white font-weight-boldest action-new-request" (click)="clickView(2)">{{ "GENERAL.CREATE" | translate }}</button>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group mb-0 text-right">
                                    <button type="submit" class="btn btn bg-success text-white font-weight-boldest  mr-2" >{{ "INPUT.FILTER" | translate }}</button>
                                    <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest ">{{ "INPUT.RESET" | translate }}</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-custom gutter-b mt-10">
        <div class="card-header d-none">
            <div class="card-title">
                <h3 class="card-label">{{ "REQUEST.TITLE | translate }}</h3>
            </div>
        </div>
        
        <div class="card-body py-0 px-0">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th>{{ "REQUEST.REQUEST" | translate }}</th>
                        <th>{{ "REQUEST.POLICY_NUM" | translate }}</th>
                        <th>{{ "REQUEST.CATEGORY" | translate }}</th>
                        <th>{{ "REQUEST.PRODUCER" | translate }}</th>
                        <th>{{ "INSURANCE.INSURED" | translate }}</th>
                        <th *ngIf="false">{{ "REQUEST.BUSINESS_LINE" | translate }} </th>
                        <th>{{ "REQUEST.REQUEST_DATECREATED" | translate }}</th>
                        <th>{{ "REQUEST.REQUEST_CREATED_2" | translate }}</th>
                        <th *ngIf="false">{{ "REQUEST.REQUEST_DATEEND_2" | translate }}</th>
                        <th>{{ "REQUEST.FRECUENCY" | translate }}</th>
                        <th>{{ "REQUEST.DATEPAYTO" | translate }}</th>
                        <th>{{ "REQUEST.STATUS" | translate }}</th>
                        <th width="14%">{{ "INPUT.OPTIONS" | translate }}</th>
                    </thead>
                    <tbody>
               
                        <tr *ngFor="let request of requestService.items$ | async; let i = index" class="status_{{request.IdEstatus}}">
                            <td>{{ request.NroSolicitud }}</td>
                            <td>{{ request.NroDePoliza }}</td>
                            <td>{{ request.CategoriaSolicitud }}</td>
                            <td>{{ request.Agencia }}</td>
                            <td>{{ request.Prospecto }}</td>
                            <td *ngIf="false">{{ request.LineaNegocioSolicitud }}</td>
                            <td>{{ request.FechaCreacion | date: 'MM/dd/yyyy'}}</td>
                            <td>{{ request.VigenciaDesde | date: 'MM/dd/yyyy'}}</td>
                            <td *ngIf="false">{{ request.VigenciaHasta | date: 'MM/dd/yyyy'}}</td>
                            <td>{{ request.FrecuenciaDePagos }}</td>
                            <td>{{ request.FechaAplicacionPago | date: 'MM/dd/yyyy' }}</td>
                            <td>{{ request.Estatus }}</td>
                            <td>
                                <button type="button" class="btn btn-sm btn-link text-center mr-1" (click)="clickView(2, request.IdSolicitud)"><i class="fa fa-edit"></i></button>
                                <button type="button" class="btn btn-sm btn-link text-center mr-1" (click)="onclickModalStatus(request.IdSolicitud, requestStatusModal)"><i class="fa fa-shield-alt"></i></button>
                            </td>
                        </tr>

                        <tr *ngIf="!(requestService.items$ | async)?.length">
                            <td colspan="9">
                                <p class="my-5"><strong>{{ "GENERAL.EMPTY_QUERY" | translate }}</strong></p>
                            </td>
                        </tr>
            
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    
</div>

<div id="request-page-2" *ngIf="templateView==2">
    <h2 class="mt-5 font-weight-bolder" *ngIf="!(request_selected)">
        <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "GENERAL.CREATE" | translate }}
    </h2>

    <h2 class="mt-5 font-weight-bolder" *ngIf="(request_selected)?.NroSolicitud">
        <i class="fa fa-shield-alt text-mid-dark font-size-h1"></i> {{ "INPUT.EDIT" | translate }}
    </h2>

    <!--
    <div id="action-success-request-1" class="alert alert-success round-0 rounded-top font-weight-bolder m-5" *ngIf="(newRequest | async)?.IdSolicitud" role="alert">
        <h5 class="alert-heading font-weight-bolder" *ngIf="newRequest | async as b" >Nro. de Solicitud {{b.NroSolicitud}}</h5>
        <p class=""><span>{{"REQUEST.SUCCESS" | translate}} </span><span>{{"REQUEST.REQUIREDFILES" | translate}}</span></p>
    </div>
    -->

    <div class="card card-custom gutter-b mt-10">
        <div class="card-body py-0 px-0">
            <div class="form-group row m-3 mt-5 justify-content-md-left">
                <div class="col-md-12">
                    <form
                    [formGroup]="requestForm"
                    (ngSubmit)="submitRequest(loadingModal, 'A')"
                    >
                        <input type="hidden" name="inputIdSolicitud" formControlName="inputIdSolicitud" >
                        <input type="hidden" name="inputIdPoliza" formControlName="inputIdPoliza" >

                        <div class="row" *ngIf="errorState == errorStates.HasError">
                            <div class="col-12 my-5">
                                <div class="alert alert-danger">{{ "REQUEST.ERROR_REQUEST" | translate}}</div>
                            </div>
                        </div>

                        <div class="row mb-4">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.REQUEST_NUM" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'REQUEST.REQUEST_NUM' | translate }}" formControlName="inputNroSolicitud" name="inputNroSolicitud"
                                    readonly>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.FRECUENCY" | translate }}</label>
                                    <input class="form-control" formControlName="inputFrecuencia" name="inputFrecuencia" readonly>
                                    <input type="hidden" class="form-control" formControlName="inputIdFrecuencia" name="inputIdFrecuencia">
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.PAYTO" | translate }}</label>
                                    <input class="form-control" formControlName="inputPayTo" name="inputPayTo" readonly>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.REQUEST_DATECREATED" | translate }}</label>
                                    <input class="form-control" formControlName="inputDateCreated" name="inputDateCreated" readonly>
                                </div>
                            </div>

                        </div>

                        <div class="row mb-4">
                            

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.CATEGORY" | translate }}</label>

                                    <select
                                    class="form-control" formControlName="inputIdCategoriaSolicitud" name="inputIdCategoriaSolicitud" required
                                    [ngClass]="{ 'is-invalid': requestForm.controls['inputIdCategoriaSolicitud'].invalid }"  (change)="changeCategoria($event.target)"
                                    >
                                        <option value="">{{ "REQUEST.SELECT_CATEGORY" | translate }}</option>

                                        <option *ngFor="let item of categorias | async" value="{{item.IdCategoriaSolicitud}}">{{ "REQUEST.CATEGORY" | translate }} {{ item.CategoriaSolicitud }}</option>
                                        
                                    </select>
                                    
                                    <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                        validation: 'required',
                                        message: 'Campo requerido.',
                                        control: requestForm.controls['inputIdCategoriaSolicitud']
                                        }"
                                    ></ng-container>
                                </div>
                            </div>

                            <div class="col-md-4" *ngIf="requestForm.value.inputIdCategoriaSolicitud == 1">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.PRODUCER" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdEntidadAgencia" name="inputIdEntidadAgencia"
                                    [required]="requestForm.value.inputIdCategoriaSolicitud == 1" (change)="changeAgenciaSucursal($event.target)"
                                    >
                                        <option value="">{{ "REQUEST.SELECT_PRODUCER" | translate }}</option>
                                        <option *ngFor="let item of agencias  | async" value="{{item.IdEntidadAgencia}}">{{ item.Agencia }}</option>
                                    </select>
                                </div>

                                <ng-container
                                    [ngTemplateOutlet]="formError"
                                    [ngTemplateOutletContext]="{
                                    validation: 'required',
                                    message: 'Campo requerido.',
                                    control: requestForm.controls['inputIdEntidadAgencia']
                                    }"
                                ></ng-container>
                            </div>

                            <div class="col-md-4" *ngIf="requestForm.value.inputIdCategoriaSolicitud == 2">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.BRANCH" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdEntidadSucursal" name="inputIdEntidadSucursal"
                                    [required]="requestForm.value.inputIdCategoriaSolicitud == 2" (change)="changeAgenciaSucursal($event.target)"
                                    >
                                        <option value="">{{ "REQUEST.SELECT_BRANCH" | translate }}</option>
                                        <option *ngFor="let item of sucursales  | async" value="{{item.IdEntidadSucursal}}">{{ item.Sucursal }}</option>
                                    </select>

                                    <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                        validation: 'required',
                                        message: 'Campo requerido.',
                                        control: requestForm.controls['inputIdEntidadSucursal']
                                        }"
                                    ></ng-container>
                                </div>
                            </div>

                            <div class="col-md-4" *ngIf="requestForm.value.inputIdCategoriaSolicitud && (requestForm.value.inputIdEntidadAgencia || requestForm.value.inputIdEntidadSucursal)">
                                <div class="form-group" >
                                    <label class="-sr-only">{{ "REQUEST.SALE_EXECUTIVE" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdEntidadAgente" name="inputIdEntidadAgente" required>
                                        <option value="">{{ "REQUEST.SALE_EXECUTIVE" | translate }}</option>
                                        <option *ngFor="let item of agentes  | async" value="{{item.IdEntidadAgente}}">{{ item.Agente }}</option>
                                    </select>
                                    <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                        validation: 'required',
                                        message: 'Campo requerido.',
                                        control: requestForm.controls['inputIdEntidadAgente']
                                        }"
                                    ></ng-container>
                                </div>
                            </div>

                            <div class="col-md-12"></div>

                            <div class="col-md-4">
                                <div class="form-group ">
                                    <label class="-sr-only">{{ "REQUEST.POLICY_NUM" | translate }}</label>
                                    <div class="input-group">
                                        <input class="form-control" placeholder="{{ 'REQUEST.POLICY_NUM' | translate }}" formControlName="inputNroPoliza" name="inputNroPoliza"
                                        readonly
                                        >
                                        <div class="input-group-append">
                                            <button type="button" class="input-group-text btn btn-primary" (click)="onclickModalSearchPolicie(filterRequestForm.value.inputIdSolicitud, filterPolicieModal)"><i class="fa fa-search"></i> {{"INPUT.SEARCH" | translate}}</button>
                                          </div>
                                    </div>
                                    <ng-container
                                        [ngTemplateOutlet]="formError"
                                        [ngTemplateOutletContext]="{
                                        validation: 'required',
                                        message: 'Campo requerido.',
                                        control: requestForm.controls['inputNroPoliza']
                                        }"
                                    ></ng-container>
                                </div>

                            </div>

                            <!--
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.BUSINESS_LINE" | translate }}</label>
                                    <select class="form-control" formControlName="inputIdLineaNegocioSolicitud" name="inputIdLineaNegocioSolicitud" required>
                                        <option value="">{{ "REQUEST.SELECT_BUSINESS_LINE" | translate }}</option>
                                        <option *ngFor="let item of lineanegocios  | async" value="{{item.IdLineaNegocioSolicitud}}">{{ item.LineaNegocioSolicitud }}</option>
                                    </select>
                                </div>
                            </div>
                            -->
                            
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INSURANCE.INSURED" | translate }}</label>
                                    <input class="form-control" placeholder="{{ 'REQUEST.PROSPECT' | translate }}" formControlName="inputProspecto" name="inputProspecto">
                                </div>
                            </div>


                            <div class="col-md-2" *ngIf="request_selected">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "INSURANCE.STATUS" | translate }}</label>
                                    <input class="form-control status_{{request_selected.IdEstatus}}" formControlName="inputStatus" name="inputStatus" readonly>
                                </div>
                            </div>

                            <div class="col-md-8">
                                <div class="form-group">
                                    <label class="-sr-only">{{ "REQUEST.SPECIAL_INSTRUCTION" | translate }}</label>
                                    <textarea class="form-control"  name="inputDescripcion" formControlName="inputDescripcion" placeholder="{{ 'REQUEST.SPECIAL_INSTRUCTION' | translate }}" row="3" style="width: 100%;"></textarea>
                                </div>
                            </div>
                        </div>
                    </form>

                    <!--
                    <div class="separator separator-solid separator-border-2 separator-light"></div>

                    <div id="action-success-request-2" class="alert alert-success round-0 rounded-top font-weight-bolder m-5" *ngIf="(newRequest | async)?.IdSolicitud" role="alert">
                        <h5 class="alert-heading font-weight-bolder" *ngIf="newRequest | async as b" >Nro. de Solicitud {{b.NroSolicitud}}</h5>
                        <p class=""><span>{{"REQUEST.SUCCESS" | translate}} </span><span>{{"REQUEST.REQUIREDFILES" | translate}}</span></p>
                    </div>
                    -->

                    <div class="row justify-content-between">
                        <div class="col-md-6 text-left">
                            <button [hidden]="request_selected.IdEstatus > 1" *ngIf="request_selected"  type="submit" class="btn btn bg-warning text-white font-weight-boldest" (click)="submitRequest(loadingModal, 'P')" >{{ "INPUT.PROCESS" | translate }}</button>
                        </div>
                        <div class="col-md-6 text-right">
                            <div class="form-group mb-0 text-right">
                                <button type="button" class="btn btn-default text-dark-50 font-weight-boldest  mr-2" (click)="clickView(1);request_selected = null;">{{ "INPUT.RETURN" | translate }}</button>
                                <button [hidden]="request_selected?.IdEstatus > 1" type="submit" class="btn btn bg-success text-white font-weight-boldest" (click)="submitRequest(loadingModal, 'A')" >{{ "INPUT.SAVE" | translate }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="request-documents" class="row" *ngIf="showDocuments$ | async">
        <div class="col-md-4" >
            <h3 class="mt-5 font-weight-bolder">{{ "REQUEST.UPLOAD_DOCUMENTS" | translate }}</h3>

            <div class="card card-custom gutter-b mt-5" style="min-height: 250px; background-color: #f2f2f2;">
                <div class="card-body py-0 px-0" style="min-height: 250px; ">
                    <div class="form-group mx-3 justify-content-md-left">
                        <form
                        [formGroup]="requestDocumentsForm"
                        >
                            <input type="hidden" name="inputIdSolicitud" formControlName="inputIdSolicitud" >

                            <div class="row">
                                <div class="col-12">

                                    <div class="loading-totalesModal mt-5" *ngIf="doc1States === docEstates.LoadingRequiredDocuments">
                                        <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
                                    </div>
<!--
                                    <div class="loading-totalesModal mt-5" *ngIf="(changeDocuments$ | async).state  === docEstates.UploadingDocument">
                                        <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "REQUEST.UPLOADING_DOCUMENT" | translate }} ...</span></div>
                                    </div>
                -->
                                    <div class="row" *ngIf="doc1States === docEstates.HasError">
                                        <div class="col-12 my-5">
                                            <div class="alert alert-danger">{{ "REQUEST.ERROR_UPLOAD_DOCUMENT" | translate}}</div>
                                        </div>
                                    </div>

                                    <div *ngFor="let item of docRequestService.items$ | async; let i = index">
                                        <div id="document-type-{{ item.IdTipoDocumento }}" class="row mt-4 mb-2 align-items-center document-type-{{ item.IdTipoDocumento }}">
                                            <div class="col-12">
                                                <label class="d-block" for="file{{ item.IdTipoDocumento }}">{{ item.TipoDocumento }} <span class="text-danger pl-10" *ngIf="item.Requerido">(*{{ "INPUT.REQUIRED" | translate}})</span></label>
                                                <div class="input-group">
                                                    <div class="custom-file">
                                                    <input type="file" class="custom-file-input" id="file{{ item.IdTipoDocumento }}" name="file{{ item.IdTipoDocumento }}" accept=".pdf" [required]="item.Requerido" (change)="preUpload($event, item.IdTipoDocumento)" 
                                                    
                                                    />
                                                    <label class="custom-file-label" id="custom-file-label-{{ item.IdTipoDocumento }}" for="file{{ item.IdTipoDocumento }}">{{ "INPUT.BTN_SEARCH_DOCUMENTS" | translate}}</label>
                                                    </div>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-secondary text-white requiredDocument-upload" *ngIf="!hasLoadindRD"  id="upload-file{{ item.IdTipoDocumento }}" type="button" (click)="onclickUploadRequiredDocument(loadingModal, item)"><i class="fas fa-cloud-upload-alt AUTH"></i>{{ "DOCUMENTS.UPLOAD_REQUIRED_DOCUMENT" | translate}}</button>
                                                    </div>
                                                    <div class="input-group-append" *ngIf="item.Cargado==1">
                                                        <button class="btn btn-primary" id="download-file{{ item.IdTipoDocumento }}" type="button" (click)="onViewDocument(loadingModal, item.IdTipoDocumento)"><i class="fa fa-eye"></i></button>
                                                    </div>
                                                    <div class="input-group-append border-0" *ngIf="item.Cargado==1">
                                                        <span class="input-group-text border-0 bg-white"><i class="fa fa-check text-success"></i></span>
                                                    </div>
                                                    
                                                </div>
                                            </div>

                                            <div class="col-12 mt-3" *ngIf="item.MultipleCarga==1">
                                                <label class="d-none">{{ "REQUEST.UPLOAD_DESCRIPTION" | translate }}</label>
                                                <input type="text" id="description{{ item.IdTipoDocumento }}" name="description{{ item.IdTipoDocumento }}" class="form-control file-description{{ item.IdTipoDocumento }}" placeholder="{{ 'REQUEST.UPLOAD_DESCRIPTION' | translate }}" />
                                            </div>

                                            <div class="col-12 mt-4" *ngIf="!(i%2)">
                                                <hr>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row" *ngIf="doc1States === docEstates.HasEmpty">
                                        <div class="col-12">
                                            <div class="alert alert-info">{{ "REQUEST" | translate}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            
        </div>

        <div class="col-md-8">
            <h3 class="mt-5 font-weight-bolder">{{ "REQUEST.DOCUMENTS_UPLOADED" | translate }}</h3>

            <div class="card card-custom gutter-b mt-5">
                <div class="card-body py-0 px-0" style="min-height: 250px;">
                    <div class="table-responsive angular-bootstrap-table">
                        <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                            <thead style="background-color: rgb(130,124,120);color:white;">
                                <th>ID</th>
                                <th>{{ "DOCUMENTS.DOCUMENT" | translate }}</th>
                                <th>{{ "INPUT.DOCUMENT_TYPE" | translate }}</th>
                                <th>{{ "REQUEST.DESCRIPTION" | translate }}</th>
                                <th></th>
                            </thead>

                            <tbody>
                                <tr *ngFor="let document of uploadedDocuments$ | async; let i = index">
                                    <td>{{document.IdDocCargados}}</td>
                                    <td>{{document.NombreDocumento}}</td>
                                    <td>{{document.TipoDocumento}}</td>
                                    <td>{{document.Descripcion}}</td>
                                    <td><button type="button" class="btn btn-sm btn-link text-center mx-2" (click)="onViewDocument(loadingModal, document.IdDocCargados)"><i class="fa fa-download"></i></button></td>
                                </tr>
                            </tbody>

                            <tfoot>

                                <tr *ngIf="!(uploadedDocuments$ | async)">
                                    <td colspan="5">
                                        <div class="alert alert-warning"><strong>{{ "REQUEST.EMPTY_UPLOAED_FILES" | translate }}</strong></div>
                                    </td>
                                </tr>
<!--
                                <tr *ngIf="!(uploadedDocuments$ | async)">

                                    <div class="loading-totalesModal m-5" >
                                        <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
                                    </div>
                                </tr>
                                -->
                            </tfoot>
                        </table>
                    </div>
                </div>

            </div>
        </div>

        <div class="clearfix"></div>

        <div class="col-md-12 col-sm-12">
            <div class="row" *ngIf="permissionMenu.VerGenerarTraking == 1">
                <div class="col-md-4 col-sm-12" >
                    <h3 class="mt-5 font-weight-bolder">{{ "REQUEST.CREATE_TRACKING" | translate }}</h3>

                    <div class="card card-custom gutter-b mt-5">
                        <div class="card-body py-0 px-0" style="min-height: 250px;">
                            <div class="form-group mx-3 justify-content-md-left">
                                <form
                                [formGroup]="trackingForm"
                                (ngSubmit)="submitTracking(loadingModal)"
                                >
                                    <input type="hidden" name="inputIdProceso" formControlName="inputIdProceso">
                                    <input type="hidden" name="inputIdDocumento" formControlName="inputIdDocumento">

                                    <div class="row" *ngIf="trackState === trackStates.HasError">
                                        <div class="col-12 my-5">
                                            <div class="alert alert-danger">{{ "REQUEST.ERROR_TRACKING" | translate}}</div>
                                        </div>
                                    </div>

                                    <div class="row mt-4 mb-2 align-items-center ">
                                        
                                        <div class="col-12">
                                            <div class="form-group">
                                                <label class="-sr-only" for="inputIdTipoGestion">{{ "REQUEST.TYPE_TRACKINGS" | translate }}</label>
                                                <select class="form-control" formControlName="inputIdTipoGestion" name="inputIdTipoGestion"
                                                >
                                                    <option value="">{{ "INPUT.SELECT" | translate }}</option>
                                                    <option *ngFor="let item of tipoGestiones  | async" value="{{item.IdTipoGestion}}">{{ item.TipoGestion }}</option>
                                                </select>

                                                <ng-container
                                                    [ngTemplateOutlet]="formError"
                                                    [ngTemplateOutletContext]="{
                                                    validation: 'required',
                                                    message: 'Campo requerido.',
                                                    control: trackingForm.controls['inputIdTipoGestion']
                                                    }"
                                                ></ng-container>
                                            </div>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label class="-sr-only">{{ "REQUEST.DESCRIPTIONS2" | translate }}</label>
                                                <textarea class="form-control"  name="inputObservacion" formControlName="inputObservacion" placeholder="{{ 'REQUEST.DESCRIPTIONS2' | translate }}" row="3" style="width: 100%;"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row justify-content-between">
                                        <div class="col-md-6 text-left">
                                        </div>
                                        <div class="col-md-6 text-right">
                                            <div class="form-group mb-0 text-right">
                                                <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest  mr-2">{{ "INPUT.RESET" | translate }}</button>
                                                <button type="submit" class="btn btn bg-success text-white font-weight-boldest" >{{ "INPUT.SAVE" | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-8 col-sm-12" >
                    <h3 class="mt-5 font-weight-bolder">{{ "REQUEST.TRACKINGS" | translate }}</h3>

                    <div class="card card-custom gutter-b">
                        <div class="card-body py-0 px-0" style="min-height: 250px;">

                            <div class="card card-custom gutter-b">
                                <div class="card-body py-0 px-0" style="min-height: 250px;">
                                    <div class="table-responsive angular-bootstrap-table">
                                        <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                                            <thead style="background-color: rgb(130,124,120);color:white;">
                                                <th>{{ "REQUEST.TYPE_TRACKING" | translate }}</th>
                                                <th *ngIf="false">{{ "REQUEST.ID_MANAGER" | translate }}</th>
                                                <th>{{ "REQUEST.MANAGER" | translate }}</th>
                                                <th>{{ "INPUT.DATE" | translate }}</th>
                                                <th></th>
                                            </thead>
                                            
                                            <tbody>
                                                <tr *ngFor="let item of gestiones$ | async; let i = index">
                                                    <td>{{item.TipoGestion}}</td>
                                                    <td *ngIf="false">{{item.IdEntidadOperador}}</td>
                                                    <td>{{item.Analista}}</td>
                                                    <td>{{item.FechaGestion | date: 'MM/dd/yyyy'}}</td>
                                                    <td><button type="button" class="btn btn-sm btn-link text-center mx-2" (click)="onModalViewTracking(viewTrackingModal, item)"><i class="fa fa-eye"></i></button></td>
                                                </tr>
                                            </tbody>
                
                                            <tfoot>
                
                                                <tr *ngIf="!(gestiones$ | async)">
                                                    <td colspan="5">
                                                        <div class="alert alert-warning"><strong>{{ "REQUEST.EMPTY_TRACKINGS" | translate }}</strong></div>
                                                    </td>
                                                </tr>
                <!--
                                                <tr *ngIf="!(uploadedDocuments$ | async)">
                
                                                    <div class="loading-totalesModal m-5" >
                                                        <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
                                                    </div>
                                                </tr>
                                                -->
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="loadingModal">
    <ng-template #loadingModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="loading-totalesModal">
                <div class="spinner spinner-track spinner-primary spinner-lg mr-15"><span class="font-weight-boldest pl-10">{{ "GENERAL.LOADING" | translate }} ...</span></div>
            </div>
        </div>
    </ng-template>
</div>

<div class="request-status-modal">

    <span *ngIf="closeResult">
        <pre>{{closeResult}}</pre>
    </span>
        
    <ng-template #requestStatusModal let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title font-weight-bolder">{{ "REQUEST.TRACKING" | translate }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="table-responsive angular-bootstrap-table">
                <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                    <thead style="background-color: rgb(130,124,120);color:white;">
                        <th>{{ "INSURANCE.DOCUMENT" | translate }}</th>
                        <th>{{ "REQUEST.TYPE_TRACKING" | translate }}</th>
                        <th *ngIf="false">{{ "REQUEST.ID_MANAGER" | translate }}</th>
                        <th>{{ "REQUEST.MANAGER" | translate }}</th>
                        <th>{{ "INPUT.DATE" | translate }}</th>
                        <th></th>
                    </thead>
                    
                    <tbody>
                        <tr *ngFor="let item of gestiones$ | async">
                            <td>{{item.IdDocumento}}</td>
                            <td>{{item.TipoGestion}}</td>
                            <td *ngIf="false">{{item.IdEntidadOperador}}</td>
                            <td>{{item.Analista}}</td>
                            <td>{{item.FechaGestion | date: 'MM/dd/yyyy'}}</td>
                            <td><button type="button" class="btn btn-sm btn-link text-center mx-2" (click)="onModalViewTracking(viewTrackingModal, item)"><i class="fa fa-eye"></i></button></td>
                        </tr>
                    </tbody>

                    <tfoot>
                        <tr *ngIf="!(gestiones$ | async)">
                            <td colspan="5">
                                <div class="alert alert-warning"><strong>{{ "REQUEST.EMPTY_TRACKINGS" | translate }}</strong></div>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn btn-success" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
        </div>
    </ng-template>
</div>

<div class="request-policie-modal">

    <span *ngIf="closeResult">
        <pre>{{closeResult}}</pre>
    </span>
        
    <ng-template #filterPolicieModal let-c="close" let-d="dismiss">
        <div class="modal-body">
            <div class="modal-header">
                <h4 class="modal-title font-weight-bolder">{{ "INPUT.SEARCH_POLICIE" | translate }}</h4>
                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>

            <div class="modal-body mx-0 px-0">

                <div class="card card-custom gutter-b">
                    <div class="card-body py-0 px-0">
                        <div class="row mx-3">
                            <div class="col-md-12 my-5">
                                <span class="font-weight-boldest font-size-h6 text-dark-50">{{ "MENU.H4FILTER" | translate}}</span>
                            </div>
                        </div>
                        <div class="form-group row mx-3 justify-content-md-left">
                            <div class="col-md-12">
                                <form
                                [formGroup]="filterPolicyForm"
                                (ngSubmit)="submitFilterPolicy(loadingModal)"
                                >
                                    <div class="row mb-3">
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label class="sr-only">{{ "INPUT.BY_POLICY_NUM" | translate }}</label>
                                                <input class="form-control" placeholder="{{ 'INPUT.BY_POLICY_NUM' | translate }}" formControlName="inputNroDePoliza" name="inputNroDePoliza">
                                            </div>
                                        </div>

                                       
            
                                        <div class="col-md-3" style="display: none;">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="sr-only">{{ "INPUT.YEAR" | translate }}</label>
                                                        <select class="form-control" placeholder="" formControlName="inputAnyo" name="inpuAnyo">
                                                            <option value="">{{ "INPUT.YEAR" | translate }}</option>
                                                            <option *ngFor="let item of anyos | async" value="{{item.IdAno}}">{{item.Ano}}</option>
                                                        </select>
                                                    </div>
                                                </div>
            
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label class="sr-only">{{ "INPUT.MONTH" | translate }}</label>
                                                        <select class="form-control" placeholder="" formControlName="inputMes" name="inputMes">
                                                            <option value="">{{ "INPUT.MONTH" | translate }}</option>
                                                            <option *ngFor="let item of meses | async" value="{{item.Mes}}">{{item.Descripcion}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
            
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label class="sr-only">{{ "INSURANCE.CATEGORY" | translate }}</label>
                                                <select class="form-control" placeholder="" formControlName="inputRamo" name="inputRamo" (change)="changeRamo($event)">
                                                    <option value="">{{ "INSURANCE.CATEGORY" | translate }}</option>
                                                    <option *ngFor="let item of ramos | async" value="{{item.IdRamo}}">{{item.Ramo}}</option>
                                                </select>
                                            </div>
                                        </div>
            
                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label class="sr-only">{{ "INSURANCE.SUB_CATEGORY" | translate }}</label>
                                                <select class="form-control" formControlName="inputSubRamo" name="inputSubRamo" ng-disabled="!IdRamo">
                                                    <option value="">{{ "INSURANCE.SUB_CATEGORY" | translate }}</option>
                                                    <option *ngFor="let item of subramos | async" value="{{item.IdSubRamo}}">{{item.SubRamo}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="col-md-3">
                                            <div class="form-group">
                                                <label class="sr-only">{{ "INPUT.FIRSTNAME" | translate }}</label>
                                                <input class="form-control" placeholder="{{ 'INPUT.FIRSTNAME' | translate }}" formControlName="inputAsegurado" name="inputAsegurado">
                                            </div>
                                        </div>
                                    </div>
            
                                    <div class="row mb-4 justify-content-end">
                                        <div class="col-md-12 align-self-end">
                                            <div class="form-group mb-0 text-right">
                                                <button type="reset" class="btn btn-default text-dark-50 font-weight-boldest mr-2 ">{{ "INPUT.RESET" | translate }}</button>
                                                <button [disabled]="activeSubmitFilterPolicy" type="submit" class="btn btn bg-success text-white font-weight-boldest " >{{ "INPUT.FILTER" | translate }}</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
       
                <div class="card card-custom gutter-b my-5">
                    <div class="card-body py-0 px-0">
                        <div class="table-responsive angular-bootstrap-table">
                            <table class="table table-head-custom table-vertical-center overflow-hidden" style="border-radius: 0.42rem;">
                                <thead style="background-color: rgb(130,124,120);color:white;">
                                    <th>
                                        {{ "INSURANCE.NUM_POLICY" | translate }}
                                    </th>
                                    <th width="20%" class="text-light">
                                        {{ "INSURANCE.INSURED" | translate }}
                                        
                                    <th class="text-light">
                                        {{ "INSURANCE.SUB_CATEGORY" | translate }}
                                    </th>
                                    <th class="text-light" *ngIf="permissionMenu.VerCompania == 1">
                                        {{ "INSURANCE.COMPANY" | translate }}
                                    </th>
                                    
                                    <th width="5%">
                                        {{ "INSURANCE.START_DATE" | translate }}
                                    </th>
                                    <th width="5%">
                                        {{ "INSURANCE.PAYTO" | translate }}
                                    </th>
                                    <th width="5%">
                                        {{ "INSURANCE.PAYMENT_FRECUENCY" | translate}}
                                    </th>
                                    <th width="5%" *ngIf="permissionMenu.VerComision == 1">
                                        {{ "INPUT.SALESCOMISSION" | translate }}
                                    </th>
                                    <th width="5%" *ngIf="permissionMenu.VerComisionAgente == 1">
                                        {{ "INPUT.AGENTCOMISSION" | translate }}
                                    </th>
                                    <th>{{"INSURANCE.STATUS" | translate }}</th>
                                    <th>&nbsp;</th>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let policy of insuranceService.items$ | async; let i = index">
                                        <td>{{ policy.NroDePoliza }}</td>
                                        <td>{{ policy.Asegurado }}</td>
                                        <td>{{ policy.SubRamo }}</td>
                                        <td *ngIf="permissionMenu.VerCompania == 1"
                                        >{{ policy.Aseguradora }}</td>
                                        <td>{{ policy.VigenciaDesde | date: 'MM/dd/yyyy' }}</td>
                                        <td>{{ policy.FechaPayTo | date: 'MM/dd/yyyy' }}</td>
                                        <td>{{ policy.FrecuenciaDePagos }}</td>
                                        <td *ngIf="permissionMenu.VerComision == 1" >{{ policy.PorcentajeComision }}%</td>
                                        <td *ngIf="permissionMenu.VerComisionAgente == 1" >{{ policy.PorcentajeComisionAgente }}%</td>
                                        <td >{{ policy.Estatus }}</td>
                                        <td>
                                            <button type="button" class="btn btn-sm btn-primary" (click)="onclickSelectPolicy(policy)">{{ "INPUT.SELECT" | translate }}</button>
                                        </td>
                                    </tr>
            
                                    <tr *ngIf="!(insuranceService.items$ | async)?.length">
                                        <td colspan="11">
                                            <p class="my-5"><strong>{{ "GENERAL.EMPTY_QUERY" | translate }}</strong></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <!--
                        <app-paginator class="d-flex justify-content-between align-items-center flex-wrap" [paginator]="paginator"
                            [isLoading]="isLoading" (paginate)="paginate($event)"></app-paginator>-->
                    </div>
                </div>
            </div>

            <div class="modal-footer ">
                <div class="form-group">
                    <button type="button" class="btn btn-secondary" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
                </div>
            </div>
        </div>
    </ng-template>
</div>

<div class="processRequestModal">
    <ng-template #processRequestModal let-c="close" let-d="dismiss">
		<div class="modal-header">
            <h4 class="modal-title">{{ "REQUEST.PROCESS_REQUEST" | translate}}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <p><strong>{{ "REQUEST.PROCESS_REQUEST_HELP" | translate }} {{ request_selected.NroDePoliza}}</strong></p>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">{{ "INPUT.CANCEL" | translate}}</button>
            <button type="button" class="btn btn-success" (click)="onclickProcessRequest(loadingModal)">{{ "INPUT.SEND" | translate }}</button>
        </div>

    </ng-template>
</div>

<div class="viewTrackingModal">
    <ng-template #viewTrackingModal let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title font-weight-bolder">{{ "REQUEST.DESCRIPTIONS2" | translate }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>

        <div class="modal-body">
            <div class="row mb-3">
                <div class="col-md-3">{{ "INPUT.DATE" | translate}}</div>
                <div class="col-md-9"><p>{{ tracking_selected.FechaGestion | date: 'MM/dd/yyyy'}}</p></div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3">{{ "REQUEST.MANAGER" | translate}}</div>
                <div class="col-md-9"><p>{{ tracking_selected.Analista }}</p></div>
            </div>
            <div class="row mb-3">
                <div class="col-md-3">{{ "REQUEST.DESCRIPTIONS2" | translate}}</div>
                <div class="col-md-9">{{ tracking_selected.Observacion }}</div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-default text-dark" (click)="c('Close click')">{{ "INPUT.CLOSE" | translate}}</button>
        </div>

    </ng-template>
</div>


<ng-template
  #formError
  let-control="control"
  let-message="message"
  let-validation="validation"
>
  <ng-container
    *ngIf="control.hasError(validation) && (control.dirty || control.touched)">
    <div class="fv-plugins-message-container">
      <div class="fv-help-block">
        {{ message }}
      </div>
    </div>
  </ng-container>
</ng-template>

<a id="download-file" href="javascript:void()" class="hide" style="display: none;" target="_blank" >download file</a>